/* eslint-disable no-unused-vars */
/* eslint-disable semi */import firebase from 'firebase/compat/app';
import { safeDeepGet } from 'iotera-base/utility/json';
 
export default class chat {
  constructor(firebase) {
      this.collection = firebase.firestore().collection('transaction_snapshot_daily');
  }
  list = payload => {
    return new Promise((resolve, reject) => {
      var filter_sd = safeDeepGet(payload, 'date')[0];
      var filter_ed = safeDeepGet(payload, 'date')[1];
      
      if (filter_sd == 'all' || filter_sd == null) {
        filter_sd = null;
      }
      if (filter_ed == 'all' || filter_ed == null) {
        filter_ed = null;
      }
      let query = this.collection;
      if (filter_sd) {
        var startfulldate = firebase.firestore.Timestamp.fromDate(filter_sd);
        query = query.where('firestore_timestamp', '>=', startfulldate);
      }

      if (filter_ed) {
        const d = filter_ed;
        d.setDate(d.getDate() + 1);
        var endfulldate = firebase.firestore.Timestamp.fromDate(d);

        query = query.where('firestore_timestamp', '<=', endfulldate);
      }
      const list = {};
      query.get().then(
        querySnapshot => {
          querySnapshot.docs.map(doc => {
            list[doc.id] = doc.data();
          });
          resolve({ code: 0, body: list });
        },
        error => {
          resolve({ code: -1, body: list });
        }
      );
    });
  };
  detail = orderID => {
    return new Promise((resolve, reject) => {
      var orderId = safeDeepGet(orderID, 'payload');
      const list = {};
      this.collection
        .where('__name__', '==', orderId)
        .get()
        .then(
          snapshot => {
            snapshot.docs.map(doc => {
              list[doc.id] = doc.data();
            });
            resolve({ code: 0, body: list });
          },
          error => {
            console.log(error);
            resolve({ code: -1, body: list });
          }
        );
    });
  };
  update = id => {
    return new Promise((resolve, reject) => {
      this.collection
        .where('__name__', '==', id)
        .get()
        .then(snapshot => {
          snapshot.docs.map(doc => {
            if (doc.id != null || doc.id != undefined) {
              this.collection
                .doc(id)
                .set(
                  {
                    active: false,
                  },
                  { merge: true }
                )
                .then(
                  () => {
                    resolve({ code: 0 });
                  },
                  error => {
                    resolve({ code: -1, body: error });
                  }
                );
            }
          });
        });
    });
  };
}
